var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUisCalender = function SvgUisCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 15.833c0 1.417 1.083 2.5 2.5 2.5h11.666c1.417 0 2.5-1.083 2.5-2.5V9.167H1.667zm14.166-12.5h-1.666V2.5c0-.5-.334-.833-.834-.833S12.5 2 12.5 2.5v.833h-5V2.5c0-.5-.333-.833-.833-.833S5.833 2 5.833 2.5v.833H4.167c-1.417 0-2.5 1.084-2.5 2.5V7.5h16.666V5.833c0-1.416-1.083-2.5-2.5-2.5"
  })));
};
export default SvgUisCalender;